import { App, StrykerAlertColor } from 'osep-react-antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import GitLabConnectionButton from './GitLabConnectionButton';
import LogoutButton from './LogoutButton';
import { Button, Divider } from 'antd';
import AtlassianConnection from './AtlassianConnection';
import { useMsal } from '@azure/msal-react';
interface Props {
  children: React.ReactNode;
  searchTerm?: string;
  selectedGroup?: string | null;
}

const AppLayout: React.FC<Props> = ({ children }) => {
  const { accounts } = useMsal();
  const [gitlabConnected, setGitLabConnected] = React.useState(true);
  const [atlassianConnectedChange, setAtlassianConnectedChange] =
    React.useState(true);

  const navigate = useNavigate();

  return (
    <App
      title="Generator"
      logo="osep"
      onLogoClick={() => navigate('/')}
      onTitleClick={() => navigate('/')}
      userStatusColor={
        (gitlabConnected ? StrykerAlertColor.SUCCESS : StrykerAlertColor.ERROR,
        atlassianConnectedChange
          ? StrykerAlertColor.SUCCESS
          : StrykerAlertColor.ERROR)
      }
      userMenu={
        <div>
          <p style={{ margin: 0 }}>Logged in as</p>
          <p style={{ marginTop: 0, fontWeight: 'bold' }}>
            {accounts[0].username}
          </p>
          <p>
            <LogoutButton />
          </p>
          <p>
            <GitLabConnectionButton
              onGitLabConnectedChange={setGitLabConnected}
            />
          </p>
          <p>
            <AtlassianConnection
              onAtlassianConnectedChange={setAtlassianConnectedChange}
            />
          </p>
          <Divider />
          <p>
            <Button
              type="primary"
              block
              onClick={() => {
                navigate(`/presets`);
              }}
            >
              Presets
            </Button>
          </p>
        </div>
      }
    >
      {children}
    </App>
  );
};

export default AppLayout;
